import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlProviderserviceService } from '../../applicationinfraestructure/services/url-providerservice.service';
import { ICondicionesMovimientos } from '../interfaces/CondicionesMovimientos';

@Injectable({
  providedIn: 'root'
})
export class CondicionesMovimientosService {

  constructor(
      private httpClient: HttpClient,
      private urlProviderService: UrlProviderserviceService
    ) { }

  public getAll(): Promise<ICondicionesMovimientos[]> {
    return this.httpClient.get<ICondicionesMovimientos[]>(this.urlProviderService.getApiUrl('getTodosCondicionesMovimientos'))
      .toPromise();
  }

  public getById(id: number): Promise<ICondicionesMovimientos> {
    return this.httpClient.get<ICondicionesMovimientos>(`${this.urlProviderService.getApiUrl('condicionesMovimientos')}/${id}`)
      .toPromise();
  }

  public create(condicionesMovimientos: ICondicionesMovimientos): Promise<ICondicionesMovimientos> {
    delete condicionesMovimientos.id;
    return this.httpClient.post<ICondicionesMovimientos>(this.urlProviderService.getApiUrl('condicionesMovimientos'), condicionesMovimientos)
      .toPromise();
  }

  public update(condicionesMovimientos: ICondicionesMovimientos): Promise<void> {
    const id = condicionesMovimientos.id;
    delete condicionesMovimientos.id;
    return this.httpClient.put<void>(`${this.urlProviderService.getApiUrl('condicionesMovimientos')}/${id}`, condicionesMovimientos)
      .toPromise();
  }

  public delete(id: number): Promise<void> {
    return this.httpClient.delete<void>(`${this.urlProviderService.getApiUrl('condicionesMovimientos')}/${id}`)
      .toPromise();
  }
}
